export function hasDateTimePassed(dateTime) {
  const givenTime = new Date(dateTime).getTime();
  const currentTime = Date.now();

  return givenTime < currentTime;
}
